import { camelCase } from 'lodash';

import { useQuery } from '@apollo/react-hooks';

import switchesQuery from './switchesQuery';
import type { SwitchesQuery, SwitchesVariables } from './types';

/**
 * Hook to query switches for the current user, regardless
 * of whether they're logged in or not. Optionally, you can
 * provide an `accountId` to query switches for the account.
 */
const useSwitch = (switchName: string, accountId?: number) => {
  const result = useQuery<SwitchesQuery, SwitchesVariables>(switchesQuery, {
    ssr: false,
    // Refetch from network in case user changes from logged
    // out to logged in, which can affect their switches.
    fetchPolicy: 'cache-and-network',
    variables: {
      accountId: accountId || 0,
      withAccount: !!accountId,
    },
  });
  const name = camelCase(switchName);
  const isProfileSwitchOn = result.data?.session.switches[name] || false;
  const isAccountSwitchOn = result.data?.account?.switches[name] || false;
  const isSwitchOn = isProfileSwitchOn || isAccountSwitchOn || false;

  return {
    isLoading: result.loading,
    isSwitchOn,
    isProfileSwitchOn,
    isAccountSwitchOn,
  };
};

export default useSwitch;
